import { ETokenType } from "../../../../enums";
import { AUTH_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  PROFILE_BY_PHONE_PATH,
  PROFILE_URL,
  REGISTRATION_PATH,
} from "./constants";
import {
  IGetProfileByPhoneResponse,
  IGetUserTokenByTypeAndIdResponse,
  IPinCodeRequestBody,
  IRegisterByPhoneRequest,
  IRegisterByPhoneResponse,
  IResetPinCodeRequestBody,
  ISetPinCodeResponse,
  IUpdateNationalIdRequestBody,
  IUpdateNationalIdResponse,
  IUpdatePinCodeRequestBody,
  IUpdateUserTokenRequestBody,
  IUserAddressBody,
  IUserAddressResponse,
  IUserAllAddressResponse,
  IUserInfoResponse,
  IVerifyPincodeResponse,
} from "./models";

// eslint-disable-next-line no-unused-vars
const defaultProvide = async () => await getToken();
const appProvide = async () => AuthConfig.getAppToken();

export const registerByPhone = (
  body: IRegisterByPhoneRequest
): Promise<IRegisterByPhoneResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}${REGISTRATION_PATH}`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const postUserPinCode = (
  userId: string,
  body: IPinCodeRequestBody
): Promise<ISetPinCodeResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/pin-code`,
    "POST",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const updateNationalId = (
  userId: string,
  body: IUpdateNationalIdRequestBody
): Promise<IUpdateNationalIdResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/national-id`,
    "PATCH",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
export const getBasicUserDetailsById = (
  id: string | number,
  publicApi?: boolean
): Promise<IUserInfoResponse> => {
  const url = `${AUTH_BASE_URL}${PROFILE_URL}/${id}/basic-info`;
  const descriptor = new ApiServiceManager(
    url,
    "GET",
    publicApi ? appProvide : defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getUserAddress = (id: string): Promise<IUserAddressResponse> => {
  const url = `${AUTH_BASE_URL}/api/addresses/${id}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const verifyPinCode = (
  userId: string,
  body: IPinCodeRequestBody
): Promise<IVerifyPincodeResponse> => {
  const url = `${AUTH_BASE_URL}/api/users/${userId}/pin-code/verify`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const updatePinCode = (
  userId: string,
  body: IUpdatePinCodeRequestBody
): Promise<IVerifyPincodeResponse> => {
  const url = `${AUTH_BASE_URL}/api/users/${userId}/pin-code`;
  const descriptor = new ApiServiceManager(url, "PATCH", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const getUserAllAddress = (
  id: number
): Promise<IUserAllAddressResponse> => {
  const url = `${AUTH_BASE_URL}${PROFILE_URL}/${id}/addresses`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const addUserAddress = (id: number, body: IUserAddressBody) => {
  const url = `${AUTH_BASE_URL}${PROFILE_URL}/${id}/addresses`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const editUserAddress = (id: number, body: IUserAddressBody) => {
  const url = `${AUTH_BASE_URL}/api/addresses/${id}`;
  const descriptor = new ApiServiceManager(url, "PUT", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const updateUserToken = (
  userId: string,
  body: IUpdateUserTokenRequestBody
) => {
  const url = `${AUTH_BASE_URL}/api/users/${userId}/tokens`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const getUserToken = (
  userId: string,
  tokenType: ETokenType
): Promise<IGetUserTokenByTypeAndIdResponse> => {
  const url = `${AUTH_BASE_URL}/api/users/${userId}/tokens/${tokenType}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const getProfileByPhone = (
  body: IRegisterByPhoneRequest
): Promise<IGetProfileByPhoneResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}${PROFILE_BY_PHONE_PATH}/${body.phoneNumber}`,
    "GET",
    appProvide
  );
  return fetchRequest(descriptor, null);
};

export const resetPinCode = (
  userId: string,
  body: IResetPinCodeRequestBody
): Promise<IVerifyPincodeResponse> => {
  const url = `${AUTH_BASE_URL}/api/users/${userId}/reset-pin-code`;
  const descriptor = new ApiServiceManager(url, "PATCH", appProvide);
  return fetchRequest(descriptor, body);
};
